export enum RouteName {
  List = 'audit-log-list',
  Detail = 'audit-log-detail',
}
